// src/components/CustomerOrderPage/ThankYouPopup.jsx
// Post-order thank you popup: confirms the order, captures interested guests for
// the mailing list, and links out to the Eventory home page.

import React, { useState } from 'react';
import { IconCheck } from '../Shared/FigmaIcons';
import api from '../../utils/api';

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const ThankYouPopup = ({ onClose }) => {
	const [email, setEmail] = useState('');
	const [status, setStatus] = useState('idle'); // idle | saving | done | error
	const [errorMsg, setErrorMsg] = useState('');

	const openHome = () => {
		window.open('/', '_blank', 'noopener,noreferrer');
	};

	const handleSubscribe = async (e) => {
		e.preventDefault();
		const clean = email.trim().toLowerCase();
		if (!EMAIL_RE.test(clean)) {
			setErrorMsg('Please enter a valid email.');
			setStatus('error');
			return;
		}
		setStatus('saving');
		setErrorMsg('');
		try {
			await api.post('/marketing/subscribe', { email: clean, sourcePage: 'thank-you' });
			setStatus('done');
		} catch (err) {
			setErrorMsg(err?.response?.data?.msg || 'Could not sign you up. Please try again.');
			setStatus('error');
		}
	};

	return (
		<div className="ev-thankyou-overlay" onClick={onClose}>
			<div className="ev-thankyou-modal" onClick={(e) => e.stopPropagation()}>
				<button className="ev-thankyou-close" onClick={onClose} aria-label="Close">
					×
				</button>
				<div className="ev-thankyou-icon" aria-hidden="true">
					<IconCheck className="ev-icon-svg" />
				</div>
				<h2>Order received</h2>
				<p>Your order is on its way to the kitchen. We’ll have it at your table shortly.</p>

				<div className="ev-thankyou-divider" />

				{status === 'done' ? (
					<p className="ev-thankyou-success">Thanks — we’ll be in touch. 💌</p>
				) : (
					<>
						<p className="ev-thankyou-lead">
							Loved how easy that was? Bring Eventory to your own event — leave your email
							and we’ll send the details.
						</p>
						<form className="ev-thankyou-subscribe" onSubmit={handleSubscribe}>
							<input
								type="email"
								className="ev-thankyou-input"
								value={email}
								onChange={(e) => {
									setEmail(e.target.value);
									if (status === 'error') setStatus('idle');
								}}
								placeholder="you@email.com"
								aria-label="Your email"
								maxLength={190}
							/>
							<button type="submit" className="ev-primary-btn" disabled={status === 'saving'}>
								{status === 'saving' ? 'Sending…' : 'Send me info'}
							</button>
						</form>
						{status === 'error' && <p className="ev-thankyou-error">{errorMsg}</p>}
					</>
				)}

				<div className="ev-thankyou-actions">
					<button className="ev-soft-btn" onClick={openHome}>
						Learn about Eventory
					</button>
					<button className="ev-soft-btn" onClick={onClose}>
						Maybe later
					</button>
				</div>
			</div>
		</div>
	);
};

export default ThankYouPopup;
